import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SortDirection } from "@air/api/types";
import { ArrowDown, Check as CheckIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { ButtonGroup } from "@air/primitive-button-group";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
import { getConfigFieldLabel } from "~/constants/SortFieldsMap";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const SortMenu = /*#__PURE__*/ memo((param)=>{
    let { onSortChange, currentSortBy, direction, sortOptions, "data-testid": testId } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const supportsDirection = currentSortBy !== "customSort";
    const onSortDirectionChange = (newDirection)=>onSortChange(currentSortBy, newDirection);
    const options = useMemo(()=>{
        const optionsArray = [
            {
                id: "sort-by",
                label: "Sort by",
                type: "title"
            }
        ];
        sortOptions.map((option)=>{
            if (option === "customSort") {
                optionsArray.push({
                    id: "custom-sort-separator",
                    type: "separator"
                });
            }
            return optionsArray.push({
                id: option,
                label: getConfigFieldLabel(option),
                onSelect: ()=>onSortChange(option, direction),
                suffix: option === currentSortBy ? /*#__PURE__*/ _jsx(CheckIcon, {
                    className: "size-4"
                }) : null,
                type: "item"
            });
        });
        return optionsArray;
    }, [
        currentSortBy,
        direction,
        onSortChange,
        sortOptions
    ]);
    return /*#__PURE__*/ _jsxs(ButtonGroup, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
                options: options,
                trigger: /*#__PURE__*/ _jsx(Button, {
                    appearance: "ghost",
                    color: "grey",
                    "data-testid": "".concat(testId, "-MENU"),
                    size: searchImprovements ? "small" : "medium",
                    children: getConfigFieldLabel(currentSortBy)
                }),
                title: "Sort by"
            }),
            supportsDirection && /*#__PURE__*/ _jsx(Tooltip, {
                label: "Sort ascending/descending",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    color: "grey",
                    "data-testid": "".concat(testId, "-DIRECTION"),
                    "data-sort": currentSortBy,
                    label: "Sort ascending/descending",
                    onClick: ()=>{
                        direction === SortDirection.desc ? onSortDirectionChange(SortDirection.asc) : onSortDirectionChange(SortDirection.desc);
                    },
                    size: searchImprovements ? "small" : "medium",
                    children: /*#__PURE__*/ _jsx(ArrowDown, {
                        className: classNames(searchImprovements ? "size-3" : "size-4", direction === SortDirection.asc ? "rotate-180" : "rotate-0")
                    })
                })
            })
        ]
    });
});
SortMenu.displayName = "SortMenu";
